import { render, staticRenderFns } from "./AppointmentStatusField.vue?vue&type=template&id=338628a5&scoped=true&"
import script from "./AppointmentStatusField.vue?vue&type=script&lang=js&"
export * from "./AppointmentStatusField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338628a5",
  null
  
)

export default component.exports